<template>
  <div class="page-header-actions flex items-center">
    <slot></slot>
  </div>
</template>
